import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=9870acc4&scoped=true"
import script from "./MyService.vue?vue&type=script&lang=js"
export * from "./MyService.vue?vue&type=script&lang=js"
import style0 from "./MyService.vue?vue&type=style&index=0&id=9870acc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9870acc4",
  null
  
)

export default component.exports